import axios from "axios";

const SESSION_KEY = "tabel_analytics_sid";
const UTM_KEY = "tabel_utm";

const backendUrl = () =>
  process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");

export function getAnalyticsSessionId() {
  try {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = `s_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return "";
  }
}

export function captureUtmFromUrl() {
  if (typeof window === "undefined") return {};
  try {
    const u = new URL(window.location.href);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const utm = {};
    let has = false;
    keys.forEach((k) => {
      const v = u.searchParams.get(k);
      if (v) {
        utm[k] = v;
        has = true;
      }
    });
    if (has) localStorage.setItem(UTM_KEY, JSON.stringify(utm));
    return getStoredUtm();
  } catch {
    return {};
  }
}

export function getStoredUtm() {
  try {
    const raw = localStorage.getItem(UTM_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function trackEvent(event, extra = {}) {
  if (typeof window === "undefined") return;
  const utm = getStoredUtm();
  const payload = {
    event,
    path: window.location.pathname + window.location.search + window.location.hash,
    referrer: document.referrer || "",
    session_id: getAnalyticsSessionId(),
    ...utm,
    ...extra,
  };
  const url = `${backendUrl()}/api/analytics/collect`;
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
      if (navigator.sendBeacon(url, blob)) return;
    }
  } catch { /* fallback */ }
  axios.post(url, payload).catch(() => {});
}

export function trackPageView(path) {
  trackEvent("page_view", { path: path || window.location.pathname + window.location.search });
}
